export default "__VITE_ASSET__PXK00hIB__"